import { render, staticRenderFns } from "./InputLabel.vue?vue&type=template&id=106bac3e&scoped=true&"
import script from "./InputLabel.vue?vue&type=script&lang=js&"
export * from "./InputLabel.vue?vue&type=script&lang=js&"
import style0 from "./InputLabel.vue?vue&type=style&index=0&id=106bac3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106bac3e",
  null
  
)

export default component.exports